// extracted by mini-css-extract-plugin
export default {"AdminPage":"SellerPage_AdminPage__638Rt","AddProduct":"SellerPage_AddProduct__vNn3S","sellerOptions":"SellerPage_sellerOptions__aDysB","OrderCard":"SellerPage_OrderCard__D9DHw"};